import { createSlice } from '@reduxjs/toolkit';
import {
  getFundManagerDetails,
  updateFundManagerDetails,
  getAssociatedFundManager,
  getReferencesFundManager,
  getPortfolioFundManager,
} from '../thunk/fundManagerDetailThunk';
const initialState = {
  fundManagerDetails: null,
  associatedFundManagerDetails: [],
  referenceFundManagerData: [],
  portfolioFundManagerData: [],
  loading: false,
  updating: false,
  error: null,
  associatedFundManagerDetailsLoading: false,
  referenceFundManagerDataLoading: false,
  portfolioFundManagerDataLoading: false,
};

const fundManagerDetailSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearContactDetails: (state) => {
      state.fundManagerDetails = null;
      state.error = null;
      state.associatedFundManagerDetails = [];
      state.referenceFundManagerData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Contact Details
      .addCase(getFundManagerDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFundManagerDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.fundManagerDetails = action.payload.data;
      })
      .addCase(getFundManagerDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Contact Details
      .addCase(updateFundManagerDetails.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateFundManagerDetails.fulfilled, (state, action) => {
        state.updating = false;
        state.fundManagerDetails = action.payload.data;
      })
      .addCase(updateFundManagerDetails.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      })

      // Associated Investments
      .addCase(getAssociatedFundManager.pending, (state) => {
        state.associatedFundManagerDetailsLoading = true;
        state.error = null;
      })
      .addCase(getAssociatedFundManager.fulfilled, (state, action) => {
        state.associatedFundManagerDetailsLoading = false;
        state.associatedFundManagerDetails = action.payload.data;
      })
      .addCase(getAssociatedFundManager.rejected, (state, action) => {
        state.associatedFundManagerDetailsLoading = false;
        state.error = action.payload;
      })

      // Reference Calls
      .addCase(getReferencesFundManager.pending, (state) => {
        state.referenceFundManagerDataLoading = true;
        state.error = null;
      })
      .addCase(getReferencesFundManager.fulfilled, (state, action) => {
        state.referenceFundManagerDataLoading = false;
        state.referenceFundManagerData = action.payload.data;
      })
      .addCase(getReferencesFundManager.rejected, (state, action) => {
        state.referenceFundManagerDataLoading = false;
        state.error = action.payload;
      })

      // get Portfolio Fund Manager
      .addCase(getPortfolioFundManager.pending, (state) => {
        state.portfolioFundManagerDataLoading = true;
        state.error = null;
      })
      .addCase(getPortfolioFundManager.fulfilled, (state, action) => {
        state.portfolioFundManagerDataLoading = false;
        state.portfolioFundManagerData = action.payload.data;
      })
      .addCase(getPortfolioFundManager.rejected, (state, action) => {
        state.portfolioFundManagerDataLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearContactDetails } = fundManagerDetailSlice.actions;
export default fundManagerDetailSlice.reducer;
